import React, { useEffect } from "react";
import "./DowntimeLog.css";
import dayjs from "dayjs";
import { DatePicker, Spin } from "antd";
import CustomTable from "../Table/CustomTable";
import { DownTimeLogOps, DownTimeOpData } from "../../Utils/constants";
import Datepicker from "../Datepicker/Datepicker";
import { DowntimeLogVar } from "../../Utils/variables";
import { getAllLogs, onDowntimeDateChange } from "../../API-Interaction/apiServices/logs.api";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment"
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { antIcon, countUpFromTime } from "../../Helpers/helpers";
import Timer from "../Timer/Timer";
dayjs.extend(customParseFormat);
const { heading } = DowntimeLogVar

const DowntimeLog = () => {

  const dispatch = useDispatch()
  const { current = null } = useSelector(state => state.plant)
  const { downTimeDate, list } = useSelector(state => state.logs)
  const { pageLoaders } = useSelector(state => state.utils.loaders)
  const { page } = useSelector(state => state.utils.reloadFlags)

  useEffect(() => {
    current?.plant && getAllLogs(dispatch, current, downTimeDate)
  }, [current, downTimeDate, page])

  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.downtimeLogs}>
      <div className="downtime-div1 p20">
        <div className="dflex justifySB alignCenter">
          <h1 className="pageHead">{heading}</h1>
          <Datepicker
            value={moment(downTimeDate) || moment(new Date())}
            format='YYYY-MM-DD'
            className="downtime-datepicker boxBorderRad boxBorder"
            size="middle"
            onChange={(date, dateString) => onDowntimeDateChange(date, dateString, dispatch, current)}
            allowClear={false}

          />
        </div>
        <div className="DownTimeTable">
          <CustomTable dataSource={list} columns={DownTimeLogOps} editable />
        </div>
      </div>
    </Spin>
  );
};

export default DowntimeLog;
